import { useState, useEffect } from 'react';

import { APP, showingResults } from 'lib/strings';
import { setMetaTags, hrefTitle } from 'lib/utils';
import { ConfluenceAPI, SearchResults } from 'lib/confluence';
import {
  Container,
  List,
  Empty,
  Input,
  Button,
  ContainerLoader,
} from 'lib/raul';
import { useQuery } from 'lib/hooks';
import { useHistory } from 'react-router';

const Search = () => {
  const [searchResults, setSearchResults] = useState<SearchResults>();
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const query = useQuery();
  const history = useHistory();
  const api = new ConfluenceAPI();

  const search = async (
    term: string,
    cursor?: string,
    start = 0,
    limit = 10
  ) => {
    setIsLoading(true);

    const results = await api.search(term, cursor, start, limit);

    if (!results.results) return;

    if (searchResults?.results && cursor) {
      results.results = [...searchResults.results, ...results.results];
    }

    setSearchResults(results);
    setIsLoading(false);
    setMetaTags(APP.SEARCH, APP.HERO);
  };

  // Load Search Data
  useEffect(() => {
    const term = query.get('searchTerm');

    if (!term) return;

    setSearchTerm(term);
    (async () => {
      await search(term);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    const { id, title } = e.currentTarget;

    history.push(`/article/${id}/${hrefTitle(title)}`);
  };

  const loadMore = async () => {
    if (!searchResults?.cursor) return;

    await search(
      searchTerm,
      searchResults.cursor,
      searchResults.start,
      searchResults.limit
    );
  };

  const onKeyDown = async (event: React.KeyboardEvent) => {
    if (event.key !== 'Enter') return;

    const term = event.currentTarget.getAttribute('value');

    if (!term) return;

    await search(term);
    setSearchTerm(term);
  };

  return (
    <>
      <div className="r-bg-primary r-p-9">
        <div className="r-bg-white r-shadow-xl">
          <Input
            defaultValue={query.get('searchTerm')}
            onKeyDown={onKeyDown}
            placeholder={APP.SEARCH}
            type="search"
          />
        </div>
      </div>
      <Container addShadow className="md:r-p-9 content">
        {searchResults?.results?.length || isLoading ? (
          <>
            {searchResults?.results?.length ? (
              <>
                <h2
                  className="r-heading-xl"
                  dangerouslySetInnerHTML={{
                    __html: showingResults(
                      String(searchResults.start),
                      String(searchResults.totalCount),
                      searchTerm
                    ),
                  }}
                />
                <List
                  handleClick={handleClick}
                  handleKeyDown={onKeyDown}
                  header={null}
                  items={searchResults.results.map(
                    ({ excerpt, friendlyLastModified, id, title }) => ({
                      chips: [friendlyLastModified],
                      id,
                      subtitle: excerpt,
                      title,
                    })
                  )}
                />
                {searchResults?.cursor && (
                  <div className="r-text-center r-pt-8">
                    <Button handleClick={loadMore}>{APP.VIEW_MORE}</Button>
                  </div>
                )}
              </>
            ) : (
              <ContainerLoader />
            )}
          </>
        ) : (
          <Empty
            description={APP.TRY_AGAIN}
            illustration="generic"
            title={APP.NO_RESULTS_FOUND}
          />
        )}
      </Container>
    </>
  );
};

export default Search;
